import type { NodeEditorData } from "tanuki-ui/extended/node-editor";

export const emptyTestData: NodeEditorData = {
  nodes: {},
  connections: {},
};